import { ServicesForPublicQuery } from "@/generated/graphql";
import { graphql, HttpResponse } from "msw";

export const servicesForPublicHandler = graphql.query<ServicesForPublicQuery>(
  "servicesForPublic",
  ({ query, variables }) => {
    return HttpResponse.json({
      data: {
        servicesForPublic: {
          dxf: {
            redirectURL: "",
            using: true,
          },
          invoice: {
            redirectURL: "http://localhost:8080/invoice",
            using: true,
          },
          bfm: {
            redirectURL: "http://localhost:8080/bfm",
            using: false,
          },
          loan: {
            redirectURL: "http://localhost:8080/loan",
            using: true,
          },
        },
      },
    });
  }
);
